
let unirest = require('unirest');
var md5 = require('md5');
const apiUrl = process.env.REACT_APP_API_URL;
const endpointBase = 'auth/' ;
const API = require ('Api') ;


 export async function login ( schoolID,  loginID, password ) {

  const res =  await unirest.post(apiUrl + endpointBase)
        .headers({
                  'Accept': 'application/json', 
                  'Content-Type': 'application/json' }
                  )
        .send( {
                "school_id": schoolID,
                "login_id": loginID ,
                "password": md5(password)
                }) ;
  return res.body ;
}
 

export async function getSysParameters ( token ) {
  const res =  await unirest.get(API.V2 + API.CONFIG  + "params" )
          .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})
  if (res.error) console.log(res.error)

  let dev = res.body.map ( (param) => {
      return (
        { param_id: param.param_id, param_value: param.param_value }
      )
  })
return dev ;
}


export async function getSession ( sessionID ) {
  // Try to getit from localStore
  let session = JSON.parse( localStorage.getItem("session"));
  if ( session && session.session_id  && ( new Date(session.due_date) > new Date() ) )  return  session ;

  const res =  await unirest.get(apiUrl + 'session/'+ sessionID);
  return res.body ;
} 